import { useContext } from 'react'
import {
  HeaderShowContext,
  HeaderShowContextValues
} from 'components/Header/HeaderShow/context'

export const useHeaderShow = (): HeaderShowContextValues => {
  return useContext(HeaderShowContext)
}
